import { ConsoleDriverConfig, Driver } from '../types';

/**
 * ConsoleDriver
 *
 * Logs all events to the console
 *
 * @param config - Config for a ConsoleDriver
 * @returns An instance of ConsoleDriver
 */
export const ConsoleDriver = ({ namespace }: ConsoleDriverConfig): Driver => {
    const state = {
        enabled: true,
    };

    return {
        // eslint-disable-next-line no-console
        initialize: async () => console.log(`${namespace}::initialize()`),
        enable: () => {
            state.enabled = true;
            // eslint-disable-next-line no-console
            console.log(`${namespace}::enable()`);
        },
        disable: () => {
            state.enabled = false;
            // eslint-disable-next-line no-console
            console.log(`${namespace}::disable()`);
        },
        setDefaultData: (data) => {
            // eslint-disable-next-line no-console
            console.log(`${namespace}::setDefaultData()`, {
                data,
            });
        },
        updateDefaultData: (data) => {
            // eslint-disable-next-line no-console
            console.log(`${namespace}::updateDefaultData()`, {
                data,
            });
        },
        trigger: (payload, defaultData) => {
            if (state.enabled)
                // eslint-disable-next-line no-console
                console.log(`${namespace}::trigger()`, {
                    payload,
                    defaultData,
                });
        },
    };
};
